import Vue from 'vue'

import VueCookies from 'vue-cookies'
Vue.use(VueCookies)

import VueLocalstorage from 'vue-localstorage'
Vue.use(VueLocalstorage)

import VueMeta from 'vue-meta'
Vue.use(VueMeta, {
  keyName: 'metaInfo',
  attribute: 'data-vue-meta',
  ssrAttribute: 'data-vue-meta-server-rendered',
  tagIDKeyName: 'vmid',
  refreshOnceOnNavigation: true
})

import 'viewerjs/dist/viewer.css'
import VueViewer from 'v-viewer'
Vue.use(VueViewer, {
  defaultOptions: {
    zIndex: 7000,
    transition: true,
    navbar: false,
    fullscreen: true,
    title: false,
    tooltip: false,
    toolbar: {
      oneToOne: {show: 1, size: 'large'},
      reset: {show: 1, size: 'large'},
      rotateLeft: {show: 1, size: 'large'},
      rotateRight: {show: 1, size: 'large'},
    },
    backdrop: true,
    button: true,
  }
})

Vue.filter("comma", val =>{
  return String(val).replace(/\B(?=(\d{3})+(?!\d))/g, ",");
})

import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
Vue.use(ElementUI)

export default {}
